import React from 'react';

import {
  FilterDiv,
  LabelFormat,
} from '@components/FilterButton/FilterButton.style';
import Icon from '@components/Icon/Icon';

export const CustomFilterIcon: () => React.ReactNode = () => {
  return (
    <>
      <FilterDiv hasFilters={false}>
        <Icon
          clickable
          color="text.primary"
          name="sliders"
          style={{ marginRight: 1 }}
        />
        <LabelFormat hasFilters={false}>Filter</LabelFormat>
      </FilterDiv>
    </>
  );
};
